@if (loading) {
  <mat-spinner />
} @else if (resultSet && summary) {
  <div class="card m-1">
    <div class="card-title m-0 pt-1 px-2">
      <div class="row">
        <div class="col">
          <h6 class="pt-1">Consult Note Summary</h6>
        </div>
        <div class="col-sm-auto text-end">
          <button type="button" class="btn btn-link m-0 p-0" (click)="collapse.toggle()">
            <fa-icon [icon]="['fas', 'exclamation-circle']" size="sm" />
            Report an Issue
          </button>
        </div>
      </div>
    </div>
    <div class="card-body p-1 container-fluid">
      @if (resultSet.partial) {
        <div class="p-2"><i><b>Warning:</b> Not all queries completed successfully. Missing information may still exist in the document.</i></div>
      }
      <div class="row pb-2">
        <div class="col px-5">
          <div>
            <b>Patient Information:</b>
            @if (!summary.patientInformation?.length) {
              <i>Information not found</i>
            }
          </div>
          @if (summary.patientInformation?.length) {
            <ul>
              @for (patient of summary.patientInformation; track patient) {
                <li class="phi">
                  <div>Name: {{ patient.patientName }}</div>
                  <div>DOB: {{ patient.patientDob | date: 'MM/dd/yyyy' }}</div>
                </li>
              }
            </ul>
          }
          @if (!showNewSpecialty) {
            <div>
              <b>Specialty of Note:</b>
              @if (summary.consultNoteSpecialty) {
                <span>{{ summary.consultNoteSpecialty }}</span>
              }
              @if (!summary.consultNoteSpecialty) {
                <i>Information not found</i>
              }
            </div>
          }
          <div>
            <b>Reason for Visit:</b>
            @if (summary.reasonForVisit) {
              <span>{{ summary.reasonForVisit }}</span>
            }
            @if (!summary.reasonForVisit) {
              <i>Information not found</i>
            }
          </div>
          <div>
            <b>Providers:</b>
            @if (!summary.providerInformation?.length) {
              <i>Information not found</i>
            }
          </div>
          @if (summary.providerInformation?.length) {
            <ul>
              @for (provider of summary.providerInformation; track provider) {
                <li>
                  <div>
                    {{ provider.providerName }}
                    @if (provider.providerSpecialty) {
                      ({{ provider.providerSpecialty }})
                    }
                    @if (provider.inOfficeEncounter) {
                      - In-Office Visit
                    }
                  </div>
                </li>
              }
            </ul>
          }
          @if (showNewSpecialty) {
            <div>
              <b>Specialty:</b>
              @if (summary.specialtyDetail?.specialty?.length) {
                <span>{{ summary.specialtyDetail.specialty }}</span>
              }
              @if (!summary.specialtyDetail?.specialty?.length) {
                <i>Information not found</i>
              }
            </div>
          }
          @if (showNewSpecialty && summary.specialtyDetail?.explanation) {
            <div>
              {{ summary.specialtyDetail.explanation }}
            </div>
          }
        </div>
        <div class="col px-5">
          <div>
            <b>Appointment Date(s):</b>
            @if (!summary.encounterDetails?.length) {
              <i>Information not found</i>
            }
          </div>
          @if (summary.encounterDetails?.length) {
            <ul>
              @for (appt of summary.encounterDetails; track appt) {
                <li>
                  <div>{{ appt.appointmentDate | date: 'MM/dd/yyyy' }} ({{ appt.appointmentType }})</div>
                </li>
              }
            </ul>
          }
          <div>
            <b>Drugs:</b>
            @if (!summary.drugs?.length) {
              <i>Information not found</i>
            }
          </div>
          @if (summary.drugs?.length) {
            <ul>
              @for (drug of summary.drugs; track drug) {
                <li>
                  <div>{{ drug }}</div>
                </li>
              }
            </ul>
          }
        </div>
      </div>
    </div>
    <div #collapse="ngbCollapse" [(ngbCollapse)]="formCollapsed" class="card-body">
      <form>
        <label for="summary-feedback">Describe any problems you see with the data:</label>
        <textarea id="summary-feedback" class="form-control mb-2 phi" name="feedback" [(ngModel)]="feedback"></textarea>
        <button type="submit" class="btn btn-primary" (click)="onSaveClick()">Save</button>
        <button type="button" class="btn btn-secondary" (click)="collapse.toggle()">Cancel</button>
      </form>
    </div>
  </div>
}
